import {
  DistanceToBeach,
  Facility,
  LayoutObjectType,
  Point,
  Price,
  View,
} from '../../domain';

export const RENT_INCLUDED_SERVICE_KEYS = [
  'manager',
  'airportTransfer',
  'technician',
  'guard',
  'cook',
  'maiden',
  'cleaning',
  'bedclothesChange',
  'breakfast',
  'water',
  'electricity',
  'wifi',
] as const;

export const RENT_PAID_SERVICE_KEYS = [
  'water',
  'electricity',
  'cleaning',
  'bedclothesChange',
] as const;

export type RentIncludedServiceKey =
  (typeof RENT_INCLUDED_SERVICE_KEYS)[number];
export type RentPaidServiceKey = (typeof RENT_PAID_SERVICE_KEYS)[number];

export type RentSelectionPaidService = {
  key: string;
  price?: number | null;
};

export type RentSelectionLayout = {
  id: number;
  num: number;
  name: string;
  comment?: string | null;
  region: string;
  districts: string[];
  type: LayoutObjectType;
  bedrooms: number;
  area?: number | null;
  views: View[];
  distanceToBeach?: DistanceToBeach | null;
  images: string[];
  layoutSchemes?: string[] | null;
  videos?: string[] | null;
  point?: Point | null;
  facilities?: Facility[] | null;
  price?: Price | null;
  hotDeal?: boolean;
  managedByVillacarte?: boolean;
  visible?: boolean;
  published?: boolean;
  publicUrl?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  priceNight?: number | null;
  currency?: string | null;
  nights?: number | null;
  total?: number | null;
  includedServices?: string[] | null;
  paidServices?: RentSelectionPaidService[] | null;
};

export type IRentSelectionPage = {
  id: string;
  createdDate: string;
  title: string;
  comment?: string | null;
  pdfLink?: string | null;
  layouts: RentSelectionLayout[];
};
